var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons / Guidebook"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.84984 17.1501L4.34984 15.7751C4.16651 15.675 4.06234 15.5292 4.03734 15.3376C4.01234 15.1459 4.06651 14.9834 4.19984 14.85L4.49984 14.55C4.56651 14.4834 4.64567 14.4375 4.73734 14.4125C4.82901 14.3875 4.9165 14.3834 4.99984 14.4001L7.19984 14.7L11.0998 10.8L4.29984 7.10005C4.04984 6.96672 3.90401 6.75838 3.86234 6.47505C3.82067 6.19172 3.89984 5.95005 4.09984 5.75005L4.34984 5.50005C4.46651 5.38338 4.59567 5.30838 4.73734 5.27505C4.87901 5.24172 5.02484 5.24172 5.17484 5.27505L14.2498 7.60005L18.1748 3.72505C18.4582 3.44172 18.8123 3.30005 19.2373 3.30005C19.6623 3.30005 20.0165 3.44172 20.2998 3.72505C20.5832 4.00838 20.7248 4.36255 20.7248 4.78755C20.7248 5.21255 20.5832 5.56672 20.2998 5.85005L16.3998 9.75005L18.7248 18.7751C18.7582 18.9417 18.754 19.1042 18.7123 19.2626C18.6707 19.4209 18.5915 19.5584 18.4748 19.6751L18.3498 19.8001C18.1165 20.0334 17.8457 20.125 17.5373 20.0751C17.229 20.0251 16.9998 19.8584 16.8498 19.5751L13.1998 12.9L9.29984 16.8L9.59984 18.9501C9.61651 19.0667 9.60817 19.175 9.57484 19.2751C9.5415 19.375 9.48317 19.4667 9.39984 19.5501L9.27484 19.6751C9.10817 19.8417 8.90817 19.9125 8.67484 19.8876C8.4415 19.8626 8.2665 19.7417 8.14984 19.5251L6.84984 17.1501Z",
    fill: "#6B6B95"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlane);
export default __webpack_public_path__ + "static/media/plane.c9524fd4b1b73d64fb53e5f9c4977f0d.svg";
export { ForwardRef as ReactComponent };